module.exports = __webpack_public_path__ + "static/media/visit-reviewdale.df3a523d.svg";